import { useRef } from "react";
import { useFileInputDnd } from "src/components/common/inputFields/fileInput/useFileInputDnd.tsx";
import { GridRowProps } from "@mui/x-data-grid/components/GridRow";
import { GridRow } from "@mui/x-data-grid-pro";

export interface GridRowWithFileDroppingProps extends GridRowProps {
	canDrop: boolean;
	onFilesDropped: (files: File[]) => void;
}

export const GridRowWithFileDropping = ({
											onFilesDropped,
											canDrop,
											style,
											...other
										}: GridRowWithFileDroppingProps) => {
	const ref = useRef(null);

	const { isDraggingOver } = useFileInputDnd({
		ref,
		canDrop: canDrop,
		onDrop: onFilesDropped
	});

	return <GridRow
		ref={ref}
		style={{
			...style,
			backgroundColor: (isDraggingOver && canDrop) ? "lightgray" : undefined
		}}
		{...other} />;
};
